var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 24,
    height: 24,
    fill: "#2255a1",
    viewBox: "0 0 432 432",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 394h8V255h80v139h22V193h80v201h20V139h82v255h20V85h82v309c4 0 6 2 6 6s-2 8-6 8H6c-2 0-6-4-6-8s4-6 6-6zm380 0V99h-54v295h54zm-102 0V153h-54v241h54zm-102 0V207h-54v187h54zm-100 0V267H28v127h54zM56 157 302 15l-38-4c-4 0-6-2-6-6s4-6 8-6l58 4v2h2c2 0 2 0 2 2h2v6l-24 54c-2 2-6 4-10 2-4 0-4-4-4-8l16-34L62 169c-2 2-6 0-8-2-2-4-2-8 2-10z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/Analytics.bd5d5690116266e3bed73625b92762a2.svg";
export { ForwardRef as ReactComponent };